import { useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';

const tabs = {
  tokens: 'Tokens',
  nfts: 'NFTs',
  stx20: 'STX20',
} as const;

export type AssetTabKey = keyof typeof tabs;

export type AssetTabName = (typeof tabs)[keyof typeof tabs];

export const useAssetsPage = () => {
  const [loading, setLoading] = useState(false);
  const [selectedTabKey, setSelectedTabKey] = useState<AssetTabKey>('tokens');

  const [isTransNotificationOpened, setTransNotificationOpened] = useState<boolean>(false);
  const [dialogDescription, setDialogDescription] = useState('');

  const { search } = useLocation();

  useEffect(() => {
    const urlParams = new URLSearchParams(search);
    const selectedTab = urlParams.get('selectedTabKey');
    if (selectedTab && tabs[selectedTab as AssetTabKey]) {
      setSelectedTabKey(selectedTab as AssetTabKey);
    }
  }, [search]);

  return useMemo(
    () => ({
      selectedTabKey,
      setSelectedTabKey,
      tabs,
      isTransNotificationOpened,
      setTransNotificationOpened,
      dialogDescription,
      setDialogDescription,
      loading,
      setLoading,
    }),
    [selectedTabKey, tabs, isTransNotificationOpened, dialogDescription, loading]
  );
};
